// extracted by mini-css-extract-plugin
module.exports = {"active":"LeftNavProjectTab_active__12xBq","inactive":"LeftNavProjectTab_inactive__3xjrc"};